import React, { useState, useEffect } from 'react';
import { Pagination, Form, Table, Container, Row, Col } from 'react-bootstrap';
import phpsvg from '../../../../Assets/svg/php.svg'
import jssvg from '../../../../Assets/svg/js.svg'
import './styles/stylerozwiazanie.css'

import obj from './objects/obj.jsx'



const INFtrojka = () => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedYear, setSelectedYear] = useState('');
    const [selectedQualification, setSelectedQualification] = useState('');
    const [selectedLanguage, setSelectedLanguage] = useState('');

    const itemsPerPage = 5;


    useEffect(() => {
        // Zamień dane z obiektu obj na tablicę
        const exams = [];
        for (const qualification in obj) {
            for (const year in obj[qualification]) {
                for (const exam in obj[qualification][year]) {
                    exams.push({
                        ...obj[qualification][year][exam][0],
                        qualification,
                        examId: exam
                    });
                }
            }
        }
        setData(exams);
        setFilteredData(exams);
    }, []);

    useEffect(() => {
        // Filtrowanie danych
        const filtered = data.filter(item => {
            const matchesSearchTerm = item.name.toLowerCase().includes(searchTerm.toLowerCase());
            const matchesYear = selectedYear ? item.year === selectedYear : true;
            const matchesQualification = selectedQualification ? item.qualification === selectedQualification : true;
            const matchesLanguage = selectedLanguage ? item.lang.toLowerCase() === selectedLanguage.toLowerCase() : true;
            return matchesSearchTerm && matchesYear && matchesQualification && matchesLanguage;
        });
        setFilteredData(filtered);
    }, [searchTerm, selectedYear, selectedQualification, selectedLanguage, data]);

    const getAvailableYears = (qualification) => {
        if (qualification === 'E14') return ['2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024'];
        if (qualification === 'INF03') return ['2021', '2022', '2023', '2024'];
        if (qualification === 'EE09') return ['2020', '2021', '2022', '2023', '2024'];
        return ['2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024'];
    };

    const getAvailableLanguages = () => {
        const languages = ['php', 'js']; // Dodaj inne dostępne języki
        return languages;
    };

 
    const descriptionExam = (description) => {
        window.alert(description);
    };

    const downloadExam = (klasyfikacja,id,rok) => {
        const repoOwner = 'PumaYT22'; 
        const repoName = 'EgzaminyZawodoweINF'; 
        const branch = 'tree/main/'; 
        const folderPath = `Egzaminy/${klasyfikacja}/${rok}/${id}/arkusz`; 

    
        const gitzipUrl = `https://kinolien.github.io/gitzip/?download=${repoOwner}/${repoName}/${branch}/${folderPath}`;

        window.open(gitzipUrl, '_blank');

    };

    const goToSolution = (klasyfikacja, rok, examId) => {
        const url = `#/rozwiazanie/${klasyfikacja}/${rok}/${examId}`;
        window.open(url, '_blank');
    };

    const goToView = (klasyfikacja, rok, examId) => {
        const url = `#/podgladinf03/${klasyfikacja}/${rok}/${examId}`;
        window.open(url, '_blank');
    };
    

    // Oblicz ilość stron
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    // Wybierz elementy dla bieżącej strony
    const currentItems = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    return (
        <Container>
        
            <h1 className="my-4">Lista arkuszy E14/EE9/INF03 📝</h1>
            <Form style={{width:"100%"}}>
                <Row className="mb-3">
                    <Col xs={11} sm={6} md={3} className="mb-3">
                        <Form.Control 
                            type="text" 
                            placeholder="Wyszukaj po nazwie" 
                            value={searchTerm}
                            style={{backgroundColor:'var(--input-bg)'}}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </Col>
                    <Col xs={11} sm={6} md={3} className="mb-3">
                        <Form.Control 
                            as="select" 
                            className='form-select'
                            value={selectedYear}
                            onChange={(e) => setSelectedYear(e.target.value)}
                            style={{backgroundColor:'var(--input-bg)'}}
                        >
                            <option value="">Wszystkie lata</option>
                            {getAvailableYears(selectedQualification).map((year, index) => (
                                <option key={index} value={year}>{year}</option>
                            ))}
                        </Form.Control>
                    </Col>
                    <Col xs={11} sm={6} md={3} className="mb-3">
                        <Form.Control 
                            as="select" 
                            className='form-select'
                            value={selectedQualification}
                            onChange={(e) => {
                                setSelectedQualification(e.target.value);
                                setSelectedYear(''); // Reset year when qualification changes
                            }}
                            style={{backgroundColor:'var(--input-bg)'}}
                        >
                            <option value="">Wszystkie Klasyfikacje</option>
                            {Array.from(new Set(data.map(item => item.qualification))).map((qualification, index) => (
                                <option key={index} value={qualification}>{qualification}</option>
                            ))}
                        </Form.Control>
                    </Col>
                    <Col xs={11} sm={6} md={3} className="mb-3">
                        <Form.Control 
                            as="select" 
                            className='form-select'
                            value={selectedLanguage}
                            onChange={(e) => setSelectedLanguage(e.target.value === 'All' ? '' : e.target.value)}
                            style={{backgroundColor:'var(--input-bg)'}}
                        >
                            <option value="All">Wszystkie języki</option>
                            {getAvailableLanguages().map((language, index) => (
                                <option key={index} value={language}>{language}</option>
                            ))}
                            
                        </Form.Control>
                    </Col>
                </Row>
            </Form>
            <div style={{ overflowX: 'auto' }}>
                <Table striped bordered hover className='inftable' style={{ backgroundColor: '#121212' }}>
                    <thead>
                        <tr>
                            <th>Nazwa</th>
                            <th>Język</th>
                            <th>Opis</th>
                            <th>Rozwiązanie</th>
                            <th>Rok</th>
                            <th>Miesiąc</th>
                            <th>Klasyfikacja</th>
                            <th>ID Arkusza</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentItems.map((item, index) => (
                            <tr key={index}>
                                <td>{item.name} <a className="link-primary " style={{cursor:"pointer"}} onClick={() => goToView(item.qualification, item.year, item.examId)}> (Podgląd)</a></td>
                                <td>{item.lang.includes('php') && item.lang.includes('js') ? (
                                                        'PHP, JS'
                                                    ) : item.lang === 'php' ? (
                                                        <>
                                                        <img width="30px" src={phpsvg} alt="php" />
                                                        </>
                                                    ) : item.lang === 'js' ? (
                                                        <>
                                                        <img width="30px" src={jssvg} alt="js" />
                                                        </>
                                                    ) : (
                                                        item.lang
                                                    )}</td>
                                <td><a className="link-danger" style={{cursor:"pointer"}} onClick={() => descriptionExam(item.desc)}>Opis Arkusza</a> / <a style={{cursor:"pointer"}} className="link-primary" onClick={() => downloadExam(item.qualification,item.examId,item.year)}>Pobierz Arkusz</a></td>
                                <td><button className='btn btn-outline-primary' onClick={() => goToSolution(item.qualification, item.year, item.examId)}
                                    >Rozwiązanie</button></td>
                                <td>{item.year}</td>
                                <td>{item.month}</td>
                                <td>{item.qualification}</td>
                                <td>{item.examId}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
            <Pagination >
                <Pagination.First onClick={() => setCurrentPage(1)} />
                <Pagination.Prev onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)} />

                {[...Array(totalPages).keys()].map(number => {
                    if (number + 1 === 1 || number + 1 === totalPages || (number + 1 >= currentPage - 2 && number + 1 <= currentPage + 2)) {
                        return (
                            <Pagination.Item
                                key={number + 1}
                                active={number + 1 === currentPage}
                                onClick={() => setCurrentPage(number + 1)}
                            >
                                {number + 1}
                            </Pagination.Item>
                        );
                    }
                    if (number + 1 === currentPage - 3 || number + 1 === currentPage + 3) {
                        return <Pagination.Ellipsis key={number + 1} />;
                    }
                    return null;
                })}

                <Pagination.Next onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)} />
                <Pagination.Last onClick={() => setCurrentPage(totalPages)} />
            </Pagination>
            <p className='text-start text-muted'>Autorem arkuszy jest: <a className='text-primary' href="https://cke.gov.pl/index.php" target='_blank' rel="noreferrer">cke.gov.pl</a></p>
        </Container>
    );
}

export default INFtrojka;
